/**
 * Order Summary Component
 * 
 * Reusable component to display order totals with fees breakdown
 * Used in cart and checkout pages
 *
 * @package Enterprise\BookingSystem
 */

/**
 * Internal dependencies
 */
import type { CartFee } from "../types/cart.types";

import './OrderSummary.scss';

export type OrderSummaryProps = {
	readonly checkoutButtonText?: string;
	readonly fees?: CartFee[];
	readonly isProcessing?: boolean;
	readonly onCheckout?: () => void;
	readonly showCheckoutButton?: boolean;
	readonly subtotal: string;
	readonly total: string;
};

export const OrderSummary = ({
	subtotal,
	fees = [],
	total,
	showCheckoutButton = false,
	checkoutButtonText = "CHECK OUT",
	onCheckout,
	isProcessing = false,
}: OrderSummaryProps) => {
	return (
		<div className="ebs-order-summary">
			<div className="ebs-order-summary__row">
				<span className="ebs-order-summary__label">Subtotal</span>
				<span className="ebs-order-summary__amount">{subtotal}</span>
			</div>

		{/* Fees breakdown */}
		{fees.length > 0 && (
			<div className="ebs-order-summary__fees">
				<span className="ebs-order-summary__fees-heading">Fees &amp; Taxes</span>
				{fees.map((fee: CartFee, feeIndex: number) => (
					<div key={feeIndex} className="ebs-order-summary__row ebs-order-summary__fee">
						<span className="ebs-order-summary__label">{fee.name}</span>
						<span className="ebs-order-summary__amount">{fee.formatted}</span>
					</div>
				))}
			</div>
		)}

			<div className="ebs-order-summary__row ebs-order-summary__total">
				<span className="ebs-order-summary__label">Total</span>
				<span className="ebs-order-summary__amount">{total}</span>
			</div>

			{showCheckoutButton && onCheckout ? (
				<button
					className="ebs-order-summary__button"
					onClick={onCheckout}
					disabled={isProcessing}
					type="button"
				>
					{isProcessing ? "Processing..." : checkoutButtonText}
				</button>
			) : null}
		</div>
	);
};

